const config = require('../../../../../config/locales_json/packs/private/validations/register.json');
const language = $('body').data("language");

$("#kt_login_signup_form #kt_login_signup_submit").on("click", function(e){
  e.preventDefault()

  var error = 0
  var email = $("#kt_login_signup_form #user_email")
  var password = $("#kt_login_signup_form #user_password")
  var rePassword = $("#kt_login_signup_form #user_password_confirmation")
  var terms = $("#kt_login_signup_form #user_terms")

  const emailRegex = /^[\w+\-.]+@[a-z\d\-.]+\.[a-z]+$/i;
  const emailVal = email.val().trim();
  const isValidEmail = emailVal ? emailRegex.test(emailVal) : false;
  
  if(!isValidEmail){
    const errorText = getTranslationValue(config, [language, "email_error"],"Debes ingresar un email");
    email.removeClass("is-invalid").addClass("is-invalid")
    email.parent().find(".invalid-feedback").remove()
    email.parent().append('<div class="invalid-feedback js-error">'+errorText+'</div>')
    error++
  } else {
    email.parent().find(".invalid-feedback").remove()
    email.removeClass("is-invalid")
  }

  if(!password.val()){
    const errorText = getTranslationValue(config, [language, "empty_password"],"Debes ingresar una contraseña");
    password.removeClass("is-invalid").addClass("is-invalid")
    password.parent().find(".invalid-feedback").remove()
    password.parent().find(".help-block").before('<div class="invalid-feedback js-error">'+errorText+'</div>')
    error++
  } else if(password.val().length < 6){
    const errorText = getTranslationValue(config, [language, "short_password"],"Debes ingresar la cantidad de cararcteres indicados");
    password.removeClass("is-invalid").addClass("is-invalid")
    password.parent().find(".invalid-feedback").remove()
    password.parent().find(".help-block").before('<div class="invalid-feedback js-error">'+errorText+'</div>')
    error++
  } else {
    password.parent().find(".invalid-feedback").remove()
    password.removeClass("is-invalid")
  }

  if(!rePassword.val()){
    const errorText = getTranslationValue(config, [language, "empty_re_password"],"Debes ingresar nuevamente tu contraseña");
    rePassword.removeClass("is-invalid").addClass("is-invalid")
    rePassword.parent().find(".invalid-feedback").remove()
    rePassword.parent().append('<div class="invalid-feedback js-error">'+errorText+'</div>')
    error++
  } else if(password.val() != rePassword.val()) {
    const errorText = getTranslationValue(config, [language, "password_not_match"],"Las contraseñas no son iguales");
    rePassword.removeClass("is-invalid").addClass("is-invalid")
    rePassword.parent().find(".invalid-feedback").remove()
    rePassword.parent().append('<div class="invalid-feedback js-error">'+errorText+'</div>')
    error++
  } else {
    rePassword.parent().find(".invalid-feedback").remove()
    rePassword.removeClass("is-invalid")
  }

  if(!terms.is(":checked")) {
    const errorText = getTranslationValue(config, [language, "check_terms_error"],"Debes aceptar los términos y condiciones");
    terms.parent().parent().find(".invalid-feedback").remove()
    terms.parent().parent().append('<div class="invalid-feedback js-error">'+errorText+'</div>')
    error++
  } else {
    //console.log("esta checkeado")
    terms.parent().parent().find(".invalid-feedback").remove()
  }
  //console.log(error)
  if(!error){
    const successText = getTranslationValue(config, [language, "not_error_text"],"Registrando...");
    $(this).addClass('send-button').val(successText)
    $("#kt_login_signup_form").submit()
  }
});

function getTranslationValue(config, keys, defaultValue) {
	if (keys.length <= 1) return defaultValue;
  
	let currentTranslation;
	let firstIteration = true;
  
	for (let key of keys) {

	  if (firstIteration) {

      if (config[key]) {
        currentTranslation = config[key];
        firstIteration = false;
      } else {
        firstIteration = false;
        return defaultValue;
      }
	  } else {
      
      if (currentTranslation[key]) {
        currentTranslation = currentTranslation[key];
      } else {
        return defaultValue;
      }
	  }
	}
	
	return currentTranslation;
}
